import { render, staticRenderFns } from "./chronicle_update.vue?vue&type=template&id=a672c002&scoped=true"
import script from "./chronicle_update.vue?vue&type=script&lang=js"
export * from "./chronicle_update.vue?vue&type=script&lang=js"
import style0 from "./chronicle_update.vue?vue&type=style&index=0&id=a672c002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a672c002",
  null
  
)

export default component.exports